module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01.07798d33d8596f9d248bc2dcd6ef073c.png";